import { render, staticRenderFns } from "./ColumnsDialog.vue?vue&type=template&id=4a8ba7f5&scoped=true"
import script from "./ColumnsDialog.vue?vue&type=script&lang=js"
export * from "./ColumnsDialog.vue?vue&type=script&lang=js"
import style0 from "./ColumnsDialog.vue?vue&type=style&index=0&id=4a8ba7f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ba7f5",
  null
  
)

export default component.exports